import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";

import { DataService } from './data.service';

@Injectable()
export class SignalRService {
    private hubConnection: HubConnection;

    constructor(private dataService: DataService){}

    public startConnection() {
        if (this.hubConnection) {
            return;
        }
        console.log('Initiating SignalR connection...');
        this.hubConnection = new HubConnectionBuilder()
                                .withUrl(this.dataService.getServerUrl() + '/processingProgressHub')
                                .withAutomaticReconnect()
                                .build();
        this.hubConnection.start()
            .then(() => console.log('SignalR connection started.'))
            .catch(err => console.error('Error while starting SignalR connection: ' + err))
        //TODO: reconnect with another projectId
    }

    public stopConnection() {
        this.hubConnection.off('reportInitialProcessingProgress');
        this.hubConnection.stop()
            .then(() => console.log('SignalR connection stopped'))
            .catch(err => console.error('Error while stopping SignalR connection: ' + err));
        this.hubConnection = undefined;
    }

    public addInitialProcessingProgressListener(handler) {
        this.hubConnection.on('reportInitialProcessingProgress', handler);
    }
}